"use client";

import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TravelerSMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="253077" id="travelers-map" className="dark bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-8 text-center md:text-left">
            <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-4 tracking-tight uppercase">
              Expedition Base Camps
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto md:mx-0 font-sans text-lg">
              Track our current global expeditions and discover the remote outposts where your next great adventure begins. Our base camps are strategically located for the ultimate wilderness access.
            </p>
          </div>

          <Card className="relative w-full h-[500px] md:h-[600px] rounded-md overflow-hidden shadow-2xl border-border/20">
            {}
            <iframe src="https://maps.google.com/maps?q=Everest%20Base%20Camp&t=&z=4&ie=UTF8&iwloc=&output=embed" className="absolute inset-0 w-full h-full border-0 grayscale-[80%] contrast-[1.2] invert-[90%] hue-rotate-[180deg]" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Wanderlust Expeditions Global Map"></iframe>

            {}
            <div className="absolute top-4 left-4 right-4 md:right-auto md:top-8 md:left-8 bg-card/80 backdrop-blur-md p-6 md:p-8 rounded-md shadow-3xl border border-white/10 max-w-sm z-10 flex flex-col gap-6">
              <div>
                <h3 className="font-default text-2xl font-bold text-foreground mb-1 uppercase tracking-tight">
                  Wanderlust HQ
                </h3>
                <p className="text-primary font-mono text-xs tracking-widest uppercase">
                  Expedition Log: Active
                </p>
              </div>

              <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3">
                  <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                  <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                    Base Camp Alpha, Khumbu Region, Himalayas
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <Clock className="size-5 text-primary shrink-0" />
                  <p className="text-muted-foreground font-sans text-sm">
                    Operations: 24/7 Seasonal
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <Phone className="size-5 text-primary shrink-0" />
                  <p className="text-muted-foreground font-sans text-sm">
                    Satellite: +1-EXP-WANDER
                  </p>
                </div>
              </div>

              <Button asChild className="w-full mt-2 group bg-primary text-primary-foreground hover:opacity-90 rounded-md" size="lg">
                <Link to="/ExpeditionsPage" newTab>
                  <Navigation className="size-4 mr-2 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
                  View Expeditions
                </Link>
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}